require('../polly/presigner');



//////////////////
// WEBPACK FOOTER
// ./node_modules/aws-sdk/lib/services/polly.js
// module id = 585
// module chunks = 0